import { RefusalSummary } from '../../../models/limits/limits.model';
import { useGet } from '../../useApi';

// GET /admin/limits/refusals/summary: purchases refused today, by limit.
const useRefusalSummary = () => {
  const { data, fetch } = useGet<RefusalSummary>('Failed to load refusals');
  return { refusals: data, fetchRefusals: () => fetch('api/v1/admin/limits/refusals/summary') };
};

export default useRefusalSummary;
